import { gql } from "graphql-tag"

import { DEFAULTS } from "../shared/utils/defaults"

const typeArticleGroup = gql`
  type ArticleGroup {
    id: ID!
    key: String
    name: String
  }

  type ArticleGroups {
    total: Int
    page: Int
    items: [ArticleGroup]
  }

  type Query {
 
    articleGroups(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      sortWithinLimits: Boolean = false
      cdn: Boolean = true
    ): ArticleGroups

}
`

export { typeArticleGroup }

export default typeArticleGroup
